import { Button } from '@nazka/nazka.mapframe.components';

import './admin-actions.styl';

function AdminActions({
  actions,
}) {
  return (
    <div className="admin-actions">
      {actions.map(({
        icon,
        title,
        onClick,
        iconColor,
        disabled,
      }) => {
        return (
          <Button
            className="admin-actions__button"
            icon={icon}
            rootElProps={{ title }}
            onClick={onClick}
            key={title}
            layout="outlined"
            color={iconColor}
            disabled={disabled}
          />
        );
      })}
    </div>
  );
}

export default AdminActions;